import { ModelRow } from "@mcleod/core";
import { DataSource } from "../databinding/DataSource";
import { Event, EventListener } from "./Event";
import { ValidationResult } from "../base/ValidationResult";

export interface DataSourceValidationListener extends EventListener<DataSourceValidationEvent> {
}

export class DataSourceValidationEvent extends Event<DataSource> {
    private _row: ModelRow;
    private _childDataSources: DataSource[];
    private _validationResults: ValidationResult[];

    constructor(dataSource: DataSource, row: ModelRow, childDataSources: DataSource[], validationResults: ValidationResult[]) {
        super(dataSource, null);
        this._row = row;
        this._childDataSources = childDataSources;
        this._validationResults = validationResults;
    }

    public get dataSource(): DataSource {
        return this.target;
    }

    public get row() {
        return this._row;
    }

    public get childDataSources(): DataSource[] {
        return this._childDataSources;
    }

    public get validationResults(): ValidationResult[] {
        return this._validationResults; //add adhoc validation results to this array
    }
}
